import React from "react";
import { Link } from "react-router-dom";
import Aside1 from "../assets/images/aside1.jpg";
import Aside2 from "../assets/images/aside2.jpg";
import Aside3 from "../assets/images/aside3.jpg";
import Aside4 from "../assets/images/aside4.jpg";
import Aside5 from "../assets/images/aside5.jpg";
import "./Footer.css";

export default function Footer() {
  const footerImages = [Aside1, Aside2, Aside3, Aside4, Aside5]; // All 5 images for desktop
  const cities = ["Toronto", "New York", "Boston", "Chicago", "New Orleans"];

  return (
    <>
      <footer className="footer-container">
        <div className="footer-images">
          {footerImages.map((img, index) => (
            <img key={index} src={img} alt={`Aside ${index + 1}`} />
          ))}
        </div>

        <div className="footer-copyright">
          &copy; 2025 Chefs2Table.com
        </div>

        <div className="footer-cities">
          {cities.map((city, index) => (
            <span key={index} className="footer-city">{city}</span>
          ))}
        </div>

        <div className="footer-admin-links">
          <Link to="/dashboard" className="admin-link">Admin Dashboard</Link>
          <Link to="/operator" className="admin-link">Operator Panel</Link>
        </div>
      </footer>

      {/* Corporate Sub-Footer */}
      <footer className="corporate-footer">
      <div className="corporate-container">
        <div className="corporate-section social-section">
          <div className="contact-info">
            <a href="mailto:hi@chefs2table.com" className="contact-email">hi@chefs2table.com</a>
          </div>
          
          <div className="social-icons">
            <a href="#" className="social-icon github" aria-label="GitHub">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
              </svg>
            </a>
            
            <a href="#" className="social-icon reddit" aria-label="Reddit">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0zm5.01 4.744c.688 0 1.25.561 1.25 1.249a1.25 1.25 0 0 1-2.498.056l-2.597-.547-.8 3.747c1.824.07 3.48.632 4.674 1.488.308-.309.73-.491 1.207-.491.968 0 1.754.786 1.754 1.754 0 .716-.435 1.333-1.01 1.614a3.111 3.111 0 0 1 .042.52c0 2.694-3.13 4.87-7.004 4.87-3.874 0-7.004-2.176-7.004-4.87 0-.183.015-.366.043-.534A1.748 1.748 0 0 1 4.028 12c0-.968.786-1.754 1.754-1.754.463 0 .898.196 1.207.49 1.207-.883 2.878-1.43 4.744-1.487l.885-4.182a.342.342 0 0 1 .14-.197.35.35 0 0 1 .238-.042l2.906.617a1.214 1.214 0 0 1 1.108-.701zM9.25 12C8.561 12 8 12.562 8 13.25c0 .687.561 1.248 1.25 1.248.687 0 1.248-.561 1.248-1.249 0-.688-.561-1.249-1.249-1.249zm5.5 0c-.687 0-1.248.561-1.248 1.25 0 .687.561 1.248 1.249 1.248.688 0 1.249-.561 1.249-1.249 0-.687-.562-1.249-1.25-1.249zm-5.466 3.99a.327.327 0 0 0-.231.094.33.33 0 0 0 0 .463c.842.842 2.484.913 2.961.913.477 0 2.105-.056 2.961-.913a.361.361 0 0 0 .029-.463.33.33 0 0 0-.464 0c-.547.533-1.684.73-2.512.73-.828 0-1.979-.196-2.512-.73a.326.326 0 0 0-.232-.095z"/>
              </svg>
            </a>
            
            <a href="#" className="social-icon instagram" aria-label="Instagram">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
            
            <a href="#" className="social-icon twitter" aria-label="X (Twitter)">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            
            <a href="#" className="social-icon youtube" aria-label="YouTube">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
            </a>
          </div>
          
          <div className="built-by">
            <span>Built by Stu2u</span>
          </div>
        </div>

        <div className="corporate-section">
          <h4 className="corporate-title">Product</h4>
          <ul className="corporate-links">
            <li><a href="#" className="corporate-link">Features</a></li>
            <li><a href="#" className="corporate-link">Enterprise</a></li>
            <li><a href="#" className="corporate-link">Pricing</a></li>
          </ul>
        </div>

        <div className="corporate-section">
          <h4 className="corporate-title">Resources</h4>
          <ul className="corporate-links">
            <li><a href="#" className="corporate-link">Download</a></li>
            <li><a href="#" className="corporate-link">Web Agents</a></li>
            <li><a href="#" className="corporate-link">Docs</a></li>
            <li><a href="#" className="corporate-link external">Forum ↗</a></li>
            <li><a href="#" className="corporate-link external">Status ↗</a></li>
          </ul>
        </div>

        <div className="corporate-section">
          <h4 className="corporate-title">Company</h4>
          <ul className="corporate-links">
            <li><Link to="/contact" className="corporate-link">Contact</Link></li>
            <li><a href="#" className="corporate-link external">Careers ↗</a></li>
            <li><a href="#" className="corporate-link">Blog</a></li>
            <li><a href="#" className="corporate-link">Community</a></li>
            <li><a href="#" className="corporate-link">Students</a></li>
            <li><a href="#" className="corporate-link">Brand</a></li>
          </ul>
        </div>

        <div className="corporate-section">
          <h4 className="corporate-title">Legal</h4>
          <ul className="corporate-links">
            <li><a href="#" className="corporate-link">Terms of Service</a></li>
            <li><a href="#" className="corporate-link">Privacy Policy</a></li>
            <li><a href="#" className="corporate-link">Data Use</a></li>
            <li><a href="#" className="corporate-link">Security</a></li>
          </ul>
        </div>
      </div>
      </footer>
    </>
  );
}